import { render } from "./DesktopMenuPopout.vue?vue&type=template&id=71cf7541&scoped=true"
import script from "./DesktopMenuPopout.vue?vue&type=script&lang=js"
export * from "./DesktopMenuPopout.vue?vue&type=script&lang=js"

import "./DesktopMenuPopout.vue?vue&type=style&index=0&id=71cf7541&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cf7541"]])

export default __exports__